"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAvailableAdUnits = exports.fetchAds = exports.AdComponent = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _fetchAds = _interopRequireDefault(require("./fetchAds"));

var _AdComponent = _interopRequireDefault(require("./AdComponent"));

var _getAvailableAdUnits = _interopRequireDefault(require("./getAvailableAdUnits"));

var _getGlobal = _interopRequireDefault(require("./utils/getGlobal"));

var _ssr = require("./utils/ssr");

var fetchAds =
/*#__PURE__*/
function () {
  var _ref = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee(config) {
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if ((0, _ssr.isClientSide)()) {
              _context.next = 2;
              break;
            }

            throw new Error('The tab-ads package can only fetch ads in the browser environment.');

          case 2:
            _context.next = 4;
            return (0, _fetchAds.default)(config);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchAds(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.fetchAds = fetchAds;
var AdComponent = _AdComponent.default;
exports.AdComponent = AdComponent;
var getAvailableAdUnits = _getAvailableAdUnits.default; // Expose functions to the global variable that are helpful
// for debugging in devtools.

exports.getAvailableAdUnits = getAvailableAdUnits;
var global = (0, _getGlobal.default)();
global.tabAds = global.tabAds || {};

global.tabAds.getAllWinningBids = function () {
  if (!(0, _ssr.isClientSide)()) {
    throw new Error('The tab-ads package can only get winning bids in the browser environment.');
  }

  var _require = require("./utils/getWinningBids"),
      getAllWinningBids = _require.getAllWinningBids;

  return getAllWinningBids();
};